import { APIS } from 'config/endpoints';
import { MainModule } from '../../app/store';
import globalApplicationContext from './globalApplicationContext';
import activeModules from './modules';

const globalState = MainModule.GlobalState.getInstance(
	new globalApplicationContext(APIS),
	activeModules,
);

export default globalState;
